import Header from "../components/Header";
import FirstRow from "../components/FirstRow";
import SecondRow from "../components/SecondRow";
import ThirdRow from "../components/ThirdRow";
import FourthRow from "../components/FourthRow";
import Footer from "../components/Footer";
import Row from "../components/Row";
export default function Home() {
  return (
    <>
      <Header />
      <Row title="Outsourcing" backgroundColor={"#FF5700"}>
        <FirstRow />
      </Row>
      <Row title="Programowanie" backgroundColor={"#FF7833"}>
        <SecondRow />
      </Row>
      <Row title="Usługi wdrożeniowe" backgroundColor={"#FF9A66"}>
        <ThirdRow />
      </Row>
      <Row title="Usługi projektowe" backgroundColor={"#FFBC99"}>
        <FourthRow />
      </Row>
      <Footer />
    </>
  );
}
